import { CardLayout, MTable } from "../v3";
import { vendorReportColumns } from "../../pages/report/constants";
import { get_date } from "../generalComponets";

export const EmployeeReportResults = ({
  reportType,
  data = {},
  loading = false,
  paginationState,
  handlePaginationChange = () => {},
}) => {
  const rows =
    data?.rows?.map((row, index) => ({
      id: index + 1 + paginationState.page * paginationState.pageSize,
      sl: index + 1 + paginationState.page * paginationState.pageSize,
      formattedDate: get_date(row.date),
      ...row,
    })) || [];

  const totalOpeningBalance = rows.reduce((sum, row) => sum + Number(row.openingBalance || 0), 0);
  const totalPurchaseAmount = rows.reduce((sum, row) => sum + Number(row.totalPurchase || 0), 0);
  const totalPaidAmount = rows.reduce((sum, row) => sum + Number(row.totalPaid || 0), 0);
  const totalClosingBalance = rows.reduce((sum, row) => sum + Number(row.closingBalance || 0), 0);
  const totalPurchase = rows.reduce((sum, row) => sum + Number(row.purchaseAmount || 0), 0);
  const totalPayment = rows.reduce((sum, row) => sum + Number(row.paymentAmount || 0), 0);

  const subtotal =
    data?.count > 0
      ? [
          {
            id: "subtotal",
            label: "Subtotal",
            totalOpeningBalance: totalOpeningBalance.toFixed(2),
            totalPurchaseAmount: totalPurchaseAmount.toFixed(2),
            totalPaidAmount: totalPaidAmount.toFixed(2),
            totalClosingBalance: totalClosingBalance.toFixed(2),
            totalPurchase: totalPurchase.toFixed(2),
            totalPayment: totalPayment.toFixed(2),
          },
        ]
      : [];

  const allRows = [...rows, ...subtotal];
  return (
    <CardLayout>
      <MTable
        // Export data
        showExportButton // TODO: implement permission
        // Table data
        columnHeaders={vendorReportColumns[reportType]} // TODO: replace with employee data
        tableRows={allRows}
        rowCount={data.count}
        loading={loading}
        paginationModel={paginationState}
        onPaginationChange={handlePaginationChange}
      />
    </CardLayout>
  );
};
